// extracted by mini-css-extract-plugin
export default {"report-modal":"ReportModal_report-modal__wHUak","submit-btn":"ReportModal_submit-btn__dp-BN","reason-input":"ReportModal_reason-input__QBvv7"};